import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import EExplorerViewType from '../../../components/explorer/entities/EExplorerViewType';

export interface IBaseSetShowModePayload {
	panelId: string;
	showMode: EExplorerViewType;
}

export interface ISetShowModePayload extends IBaseSetShowModePayload {}

export interface IReadonlySetShowModePayload extends IBaseSetShowModePayload {}

export type SetShowModePayload = ReadonlyRecord<IReadonlySetShowModePayload>;

export const SetShowModePayloadFactory = Record<IReadonlySetShowModePayload>({
	panelId: '',
	showMode: EExplorerViewType.List
});

export const SetShowModePayloadFactoryFromJS = function (payload: ISetShowModePayload) {
	return SetShowModePayloadFactory({
		panelId: payload.panelId,
		showMode: payload.showMode
	});
};
